// source: pbtypes/gen/scan_output/scan_mesh.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_mesh_util_aligned_box_3f_pb = require('../../../pbtypes/gen/mesh_util/aligned_box_3f_pb.js');
goog.object.extend(proto, pbtypes_gen_mesh_util_aligned_box_3f_pb);
goog.exportSymbol('proto.scan_output.ScanMesh', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scan_output.ScanMesh = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scan_output.ScanMesh, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scan_output.ScanMesh.displayName = 'proto.scan_output.ScanMesh';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scan_output.ScanMesh.prototype.toObject = function(opt_includeInstance) {
  return proto.scan_output.ScanMesh.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scan_output.ScanMesh} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_output.ScanMesh.toObject = function(includeInstance, msg) {
  var f, obj = {
meshId: jspb.Message.getFieldWithDefault(msg, 1, ""),
type: jspb.Message.getFieldWithDefault(msg, 2, ""),
path: jspb.Message.getFieldWithDefault(msg, 3, ""),
boundingBox: (f = msg.getBoundingBox()) && pbtypes_gen_mesh_util_aligned_box_3f_pb.AlignedBox3f.toObject(includeInstance, f),
gltfRotationCorrectionOmitted: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scan_output.ScanMesh}
 */
proto.scan_output.ScanMesh.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scan_output.ScanMesh;
  return proto.scan_output.ScanMesh.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scan_output.ScanMesh} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scan_output.ScanMesh}
 */
proto.scan_output.ScanMesh.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMeshId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPath(value);
      break;
    case 4:
      var value = new pbtypes_gen_mesh_util_aligned_box_3f_pb.AlignedBox3f;
      reader.readMessage(value,pbtypes_gen_mesh_util_aligned_box_3f_pb.AlignedBox3f.deserializeBinaryFromReader);
      msg.setBoundingBox(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGltfRotationCorrectionOmitted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scan_output.ScanMesh.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scan_output.ScanMesh.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scan_output.ScanMesh} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_output.ScanMesh.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMeshId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBoundingBox();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      pbtypes_gen_mesh_util_aligned_box_3f_pb.AlignedBox3f.serializeBinaryToWriter
    );
  }
  f = message.getGltfRotationCorrectionOmitted();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional string mesh_id = 1;
 * @return {string}
 */
proto.scan_output.ScanMesh.prototype.getMeshId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.scan_output.ScanMesh} returns this
 */
proto.scan_output.ScanMesh.prototype.setMeshId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string type = 2;
 * @return {string}
 */
proto.scan_output.ScanMesh.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.scan_output.ScanMesh} returns this
 */
proto.scan_output.ScanMesh.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string path = 3;
 * @return {string}
 */
proto.scan_output.ScanMesh.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.scan_output.ScanMesh} returns this
 */
proto.scan_output.ScanMesh.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional mesh_util.AlignedBox3f bounding_box = 4;
 * @return {?proto.mesh_util.AlignedBox3f}
 */
proto.scan_output.ScanMesh.prototype.getBoundingBox = function() {
  return /** @type{?proto.mesh_util.AlignedBox3f} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_mesh_util_aligned_box_3f_pb.AlignedBox3f, 4));
};


/**
 * @param {?proto.mesh_util.AlignedBox3f|undefined} value
 * @return {!proto.scan_output.ScanMesh} returns this
*/
proto.scan_output.ScanMesh.prototype.setBoundingBox = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scan_output.ScanMesh} returns this
 */
proto.scan_output.ScanMesh.prototype.clearBoundingBox = function() {
  return this.setBoundingBox(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scan_output.ScanMesh.prototype.hasBoundingBox = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional bool gltf_rotation_correction_omitted = 5;
 * @return {boolean}
 */
proto.scan_output.ScanMesh.prototype.getGltfRotationCorrectionOmitted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scan_output.ScanMesh} returns this
 */
proto.scan_output.ScanMesh.prototype.setGltfRotationCorrectionOmitted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


goog.object.extend(exports, proto.scan_output);
